import { Fragment } from "react";
import { Cluster } from "@googlemaps/markerclusterer";
import Marker from "./Marker";
import useCluster from "./useCluster";
import ArtistsPopup from "./ArtistsPopup";
import useMapContext from "./useMapContext";

interface Props {
  artists: Artist[];
  day: string;
}

export default function ArtistMarkers({ artists, day }: Props) {
  const { assets, map, strings, openInfoWindow } = useMapContext();

  const handleClusterClick = (
    event: google.maps.MapMouseEvent,
    cluster: Cluster,
    map: google.maps.Map
  ) => {
    if (map.getZoom() == 18) {
      const artists = cluster.markers.map(
        (m: google.maps.Marker) => m.get("artist") as Artist
      );
      openInfoWindow(
        <ArtistsPopup
          artists={artists}
          position={cluster.position}
          strings={strings}
        />,
        map,
        cluster.position
      );
    } else {
      map.fitBounds(cluster.bounds);
    }
  };

  const showArtist = (artist: Artist) => () => {
    const pos = new google.maps.LatLng(artist.position);

    openInfoWindow(
      <ArtistsPopup artists={[artist]} position={pos} strings={strings} />,
      map,
      pos
    );
  };

  const cluster = useCluster(
    map,
    handleClusterClick,
    day == "saturday" ? "#2E6FF6" : "#FB80AC"
  );

  const icon = {
    url: assets[day],
    size: new google.maps.Size(25, 25),
    scaledSize: new google.maps.Size(25, 25)
  };

  return (
    <Fragment>
      {artists.map((a) => (
        <Marker
          key={a.id}
          cluster={cluster}
          artist={a}
          onClick={showArtist(a)}
          icon={icon}
          title={a.name}
          position={a.position}
        />
      ))}
    </Fragment>
  );
}
